<template>
  <div class="disciplines">
      <h3 class="disciplines__title">Дисциплины</h3>
      <div class="disciplines__list">  
          <el-collapse 
            :class="['disciplines__item', currentDiscipline===discipline.id ? 'ativeItems': '']"
            v-for="(discipline, index) in disciplineData"
            :key="index"
            v-model="activeName" accordion >
            <el-collapse-item :title="discipline.name" :name="index">
                <router-link class="item-btn" :to="`/disciplines/viewing-disciplines/${discipline.id}?type=${discipline.type}`">Материалы</router-link>
                <router-link class="item-btn" :to="`/disciplines/viewing-groups/${discipline.id}?type=${discipline.type}`">Группы</router-link>
            </el-collapse-item>
            </el-collapse>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            activeName:'',
            currentDiscipline: null,
            disciplineData: []
        }
    },
    computed:{
        mobileMode(){
            return this.$store.state.mobileMode
        }
    },
    methods: {
        ...mapActions(['fetchDataForPage']),
    },
    mounted() {
        this.fetchDataForPage(this.$route.path).then(()=>{
            this.disciplineData = this.$store.state.dataPage.disciplines
        })
    },
}
</script>

<style lang="scss">
    .disciplines{
        display: flex;
        flex-wrap: wrap;
        .disciplines__title{
            width: 100%;
        }
        .disciplines__list{
            width: 100%;
            overflow: hidden;
        }
        .el-collapse-item__header{
            font-size: 15px;
            height: max-content;
            line-height: 1.5;
            padding: 15px 0;
        }   
        .el-collapse-item__content{
            display: flex;
            padding-bottom: 0;
            
        }
        .item-btn{
            font-size: 16px;
            color: $brand-clr-1;
            transition-duration: 0.3s;
            transition-property: background-color color;
            display: flex;
            justify-content: center;
            padding: 10px;
            width: 50%;
            &:hover{
                color: $basic-white;
                background-color: $brand-clr-1;
            }
        }
    }
</style>